import { buildVersion } from '@/core/build-version';

const RELOADED_BUILD_KEY = 'chunk-reloaded-build';
const CHUNK_LOAD_ERROR =
  /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;

export const isChunkLoadError = (error: unknown) =>
  error instanceof Error && CHUNK_LOAD_ERROR.test(error.message);

// A deploy deletes the previous chunks: reload once per build to get the new ones, never in a loop.
export function reloadForNewBuild(): boolean {
  const build = buildVersion() ?? 'dev';
  try {
    if (sessionStorage.getItem(RELOADED_BUILD_KEY) === build) {
      return false;
    }
    sessionStorage.setItem(RELOADED_BUILD_KEY, build);
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
